function drawerVariant(){
  document.querySelectorAll('.cd-related-products .variant-grid').forEach(function(sizeList){
    sizeList.addEventListener('click',function(e){
      e.preventDefault();
      let variant_id;
      sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
        removeActive.classList.remove('active');
      });
      sizeList.classList.add('active');
      let nextSibling = sizeList.closest('.grid-variant-outer-wrap').nextElementSibling;
      let prevSibling = sizeList.closest('.grid-variant-outer-wrap').previousElementSibling;
      if(nextSibling || prevSibling){
        if(nextSibling) nextSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
          if(!siblingList.classList.contains('active')){
            return false;
          }
        })
        if(prevSibling) prevSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
          if(!siblingList.classList.contains('active')){
            return false;
          }
        })
        let combineValue = '';
        let count = 0;
        sizeList.closest('.grid-variant-outer').querySelectorAll('.variant-grid.active').forEach((activeValue) => {
          count++;
          if(combineValue == ''){
            combineValue = activeValue.getAttribute('data-title')
          }else{
            combineValue = combineValue + ' / ' + activeValue.getAttribute('data-title')
          }
        })
        sizeList.closest('.grid-imagebox').querySelectorAll('.combine-variant-detail li').forEach((finalList) => {
          let title = finalList.getAttribute('data-title');
          if(title == combineValue){
            variant_id = finalList.dataset.id;
          }
        })
      }else{
        variant_id = sizeList.dataset.id;
      }
      console.log('variant_id',variant_id);
      if(variant_id != undefined){
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422){
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  let right = window.innerWidth - document.body.clientWidth;
                  if(document.querySelector('body').classList.contains('scroll-up')){
                    document.querySelector('body').style.paddingRight = right+'px';
                    document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
                    document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
                    document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
                    document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
                  }else{
                    document.querySelector('body').style.paddingRight = '';
                    document.querySelector('main').style.width = '';
                    document.getElementById('shopify-section-announcement-bar').style.width = '';
                    document.getElementById('shopify-section-header').style.width = '';
                    document.getElementById('shopify-section-footer').style.width = '';
                  }
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      }
    });
  });
}
// function drawerQuickBuy(){
//   document.querySelectorAll('.cd-related-products .quick_view_button').forEach((drawerQuickBtn) => {
//     drawerQuickBtn.addEventListener('click',function(e){
//       e.preventDefault();
//       let variant_id = drawerQuickBtn.dataset.id;
//       let error_grid_outer = drawerQuickBtn.closest('.snippet-product-grid');
//       let error_grid = error_grid_outer.querySelector('.grid-error');
//       let formData = {
//         'items': [{
//           'id': variant_id,
//           'quantity': 1
//         }]
//       };
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       })
//       .then((response) => response.json())
//       .then((data) => {
//         if(data.status == 422){
//           error_grid.innerHTML = data.description;
//           setTimeout(function(e){
//             error_grid.innerHTML = '';
//           },2000);
//         }else{          
//           if(document.location.href.indexOf('/cart') > -1) {
//             window.location.href = "/cart";
//           }else{
//             if(typeof load_cart == 'function'){
//               load_cart();
//               setTimeout(function(e){
//                 let right = window.innerWidth - document.body.clientWidth;
//                 if(document.querySelector('body').classList.contains('scroll-up')){
//                   document.querySelector('body').style.paddingRight = right+'px';
//                   document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
//                   document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
//                   document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
//                   document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
//                 }else{
//                   document.querySelector('body').style.paddingRight = '';
//                   document.querySelector('main').style.width = '';
//                   document.getElementById('shopify-section-announcement-bar').style.width = '';
//                   document.getElementById('shopify-section-header').style.width = '';
//                   document.getElementById('shopify-section-footer').style.width = '';
//                 }
//                 document.querySelector('body').classList.add('open-drawer');
//               },500);
//             }else{
//               window.location.href = "/cart";
//             }
//           }
//           const url = '/cart.js';
//           fetch(url)
//           .then((resp) => resp.json())
//           .then(function(data) {
//             var cart_count = data.item_count;
//             if(cart_count>0){
//               document.querySelector('.cart-count').innerHTML = cart_count;
//             }else{
//               document.querySelector('.cart-count').innerHTML = '';
//             }
//           })
//           .catch(function(error) {
//             console.log(error);
//           })
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//     })
//   })
// }

function drawerQuickBuy(){
  document.querySelectorAll('.cd-related-products .quick_view_button').forEach((drawerQuickBtn) => {
    drawerQuickBtn.addEventListener('click',function(e){
      e.preventDefault();
      let url = drawerQuickBtn.getAttribute('data-url');
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.querySelector('body').classList.add('open-quick-buy');
        document.getElementById('quickView').getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((error) => {
        console.error(error);
      });
    });
  });
}
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    let drawerRelated;
    if(document.querySelectorAll('.item-row').length > 0){
      fetch(document.querySelector('.cart-also-link').getAttribute('data-url'))
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-also-link');
        if (recommendations && recommendations.innerHTML.trim().length) {
          document.querySelector('.cart-also-link').innerHTML = recommendations.innerHTML;
        }
        if (html.querySelector('.grid__item')) {
          document.querySelector('.cart-also-link').classList.add('product-recommendations--loaded');
        }
        drawerRelated = new Swiper(".cd-related-products",{
          slidesPerView: "auto",
          loop: false,
          navigation: {
            nextEl: '.cart-also-link .swiper-button-next',
            prevEl: '.cart-also-link .swiper-button-prev',
          },
        });
        drawerQuickBuy();
        drawerVariant();
      })
      .catch(e => {
        console.error(e);
      });
    }
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    let right = window.innerWidth - document.body.clientWidth;
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        if(document.querySelector('body').classList.contains('scroll-up') || document.querySelector('body').classList.contains('scroll-down')){
          document.querySelector('body').style.paddingRight = right+'px';
          document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
          document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
          document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
          document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
        }else{
          document.querySelector('body').style.paddingRight = '';
          document.querySelector('main').style.width = '';
          document.getElementById('shopify-section-announcement-bar').style.width = '';
          document.getElementById('shopify-section-header').style.width = '';
          document.getElementById('shopify-section-footer').style.width = '';
        }
        document.querySelector('.cart_popup').innerHTML = '';
        let menusActive = document.querySelectorAll(".mega-list.active");
        menusActive.forEach((menuActive) => {
          menuActive.classList.remove("active");
        });
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-mobile-search','open-quick-buy','stickybar','open-nav','open-account-popup');
        setTimeout(() => {
          document.querySelector('body').classList.toggle('open-drawer');
        }, 100);
        if(drawerRelated) drawerRelated.update();
      });
    });
    document.querySelectorAll('.item_plus').forEach(function(item) {
      item.addEventListener('click', function() {
        var input = this.previousElementSibling.querySelector('input');
        input.value = parseInt(input.value) + 1;
        var new_line = this.getAttribute('data-line-item');
        var new_qty = this.closest('.main_qty').querySelector('input.cart_qty').value;
        addItem(new_line, new_qty);
      });
    });
    document.querySelectorAll('.item_minus').forEach(function(itemMinus) {
      itemMinus.addEventListener('click', function() {
        var centerQtyInput = this.nextElementSibling.querySelector('.center_qty input');
        var currentQty = parseInt(centerQtyInput.value);
        if(currentQty > 0){
          centerQtyInput.value = currentQty - 1;
          var newLine = this.getAttribute('data-line-item');
          var newQty = this.closest('.main_qty').querySelector('input.cart_qty').value;
          addItem(newLine, newQty);
        }
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        if(document.querySelector('body').classList.contains('open-filter')){
          if(document.querySelector('body').classList.contains('scroll-down')){
            document.querySelector('body').classList.add('filter-sticky');
          }
        }
        if(document.querySelector('body').classList.contains('scroll-up') || document.querySelector('body').classList.contains('scroll-down')){
          if(document.querySelector('body').classList.contains('open-drawer') || document.querySelector('body').classList.contains('open-account-popup') || document.querySelector('body').classList.contains('open-search') || document.querySelector('body').classList.contains('open-nav')){
            document.querySelector('body').style.paddingRight = '';
            document.querySelector('main').style.width = '';
            document.getElementById('shopify-section-announcement-bar').style.width = '';
            document.getElementById('shopify-section-header').style.width = '';
            document.getElementById('shopify-section-footer').style.width = '';
          }else{
            document.querySelector('body').style.paddingRight = right+'px';
            document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
            document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
            document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
            document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
          }
        }
        let menusActive = document.querySelectorAll(".mega-list.active");
        menusActive.forEach((menuActive) => {
          menuActive.classList.remove("active");
        });
        document.querySelector('body').classList.remove('open-menu','open-search','open-full-search','open-sort','open-filter','open-size-chart','open-account-popup','open-nav');
        document.querySelector('.quick-buy-popup').innerHTML = '';
      });
    });
    document.querySelector('.cart-drawer-close').addEventListener('click', function(e) {
      document.querySelector('body').classList.remove('open-drawer');
    });
    document.querySelector('.overlay-box').addEventListener('click',function(e){
      if (window.matchMedia("(max-width: 768px)").matches) {
        if (document.querySelector('body').classList.contains('open-drawer')) {
          document.querySelector('body.open-drawer').classList.remove('open-quick-buy');
          document.querySelector('body.open-drawer').classList.add('open-drawer');
          document.querySelector('.quick-buy-popup').innerHTML = '';
        }
      } else {
        document.querySelector('body').classList.remove('open-drawer');
      }
    });
    initFreeGift();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
          document.querySelector('.cart-count').innerHTML = cart_count;
      }else{
          document.querySelector('.cart-count').innerHTML = '';
      }
    })
    .catch(function(error) {
      console.log(error);
    })
    setTimeout(() => {
      translatePromoText();
    }, 1000);
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
function addItem(new_line, new_qty) {
  const data = { 'line': new_line, 'quantity': new_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function translatePromoText() {
  const promoEl = document.querySelector('.docapp-free-shipping-promo');
  const couponInput = document.querySelector('input[name="temp-discount"].docapp-coupon-input--input');
  const couponBtn = document.querySelector('.docapp-coupon-input--button-text');
  const freeShip = document.querySelector('.docapp-right.docapp-free-shipping-price');
  const totalCart = document.querySelector('.docapp-cart-item.docapp-est-total.docapp-perm .docapp-left');
  const discountMessage = document.querySelector('.docapp-coupon-input--message-container.docapp-alert-success');
  const discount = document.querySelector('.docapp-cart-item.docapp-cart-discount.docapp-clearfix .docapp-left');
  const subtotal = document.querySelector('.docapp-cart-item.docapp-cart-subtotal .docapp-left');
  if (window.location.href.includes('/en')) {
    if (promoEl) {
      promoEl.innerHTML = promoEl.innerHTML.replace('Nog', '').replace('tot gratis verzending', 'for free shipping');
    }
    if (couponInput) {
      couponInput.placeholder = 'Discount code';
    }
    if (couponBtn) {
      couponBtn.innerHTML = 'Apply';
    }
    if (freeShip) {
      freeShip.innerHTML = 'Free shipping!';
    }
    if (totalCart) {
      totalCart.innerHTML = '<strong>Total</strong>';
    }
    if (discount) {
      discount.innerHTML = 'Discount';
    }
    if (subtotal) {
      subtotal.innerHTML = 'Total excl. shipping';
    }
    if (discountMessage) {
      discountMessage.innerHTML = discountMessage.innerHTML.replace('Kortingscode', 'Discount code').replace('toegepast', 'applied').replace('je hebt','you saved ').replace('bespaard','');
    }
  } else if (window.location.href.includes('/de')) {
    
    if (promoEl) {
      promoEl.innerHTML = promoEl.innerHTML.replace('Nog', '').replace('tot gratis verzending', 'für kostenlosen Versand');
    }
    if (couponInput) {
      couponInput.placeholder = 'Rabattcode';
    }
    if (couponBtn) {
      couponBtn.innerHTML = 'Anwenden';
    }
    if (freeShip) {
      freeShip.innerHTML = 'Kostenloser versand!';
    }
    if (totalCart) {
      totalCart.innerHTML = '<strong>Gesamt<strong/>';
    }
    if (discount) {
      discount.innerHTML = 'Rabatt';
    }
    if (subtotal) {
      subtotal.innerHTML = 'Gesamt exkl. Versandkosten';
    }
    if (discountMessage) {
      discountMessage.innerHTML = discountMessage.innerHTML.replace('Kortingscode', 'Rabattcode').replace('toegepast', 'angewendet').replace('je hebt','Sie haben').replace('bespaard','gespart');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function(){
    translatePromoText();
  }, 1000);

  const observer = new MutationObserver(function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (document.body.classList.contains('docapp-with-discount') || !document.body.classList.contains('docapp-with-discount')) {
          translatePromoText();
        }
      }
    }
  });
  observer.observe(document.body, { attributes: true });
});

function initFreeGift() {
  // Show the restricted cart banner if the user arrived via the gated URL.
  // We do NOT return early here — any PDP banner in the same DOM still needs
  // its event listeners bound regardless of the cart banner's visibility.
  document.querySelectorAll('.cart-free-gift[data-restricted="true"], .pdp-free-gift[data-restricted="true"]').forEach(restrictedBanner => {
    if (sessionStorage.getItem('freeGiftUnlocked') === 'true') {
      restrictedBanner.removeAttribute("data-toggle");
      restrictedBanner.style.removeProperty('display');
    }
  });

  const customSelects = document.querySelectorAll('.free-gift__custom-select');

  customSelects.forEach(customSelect => {
    // Guard against duplicate listeners on persistent DOM elements (e.g. PDP banner).
    // Cart drawer elements are replaced wholesale on each load_cart() call so they
    // are always fresh and will never carry this attribute.
    if (customSelect.dataset.giftInitialized) return;
    customSelect.dataset.giftInitialized = 'true';

    const trigger = customSelect.querySelector('.free-gift__select-trigger');
    const triggerInnerText = trigger.querySelector('.select-size');
    const dropdown = customSelect.querySelector('.free-gift__select-dropdown');
    const options = customSelect.querySelectorAll('.free-gift__select-option');
    const hiddenSelect = customSelect.querySelector('.free-gift__variant-select');
    const card = customSelect.closest('.free-gift__card');

    if (!trigger || !dropdown) {
      console.warn('Missing trigger or dropdown for custom select');
      return;
    }

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
      trigger.classList.toggle('open');
    });

    options.forEach(option => {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        const value = this.getAttribute('data-value');
        const text = this.textContent.trim();

        triggerInnerText.innerHTML = text;
        trigger.classList.remove('open');
        dropdown.classList.remove('open');

        options.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');

        if (hiddenSelect) {
          hiddenSelect.value = value;
        }
        if (card) {
          card.setAttribute('data-variant-id', value);
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!customSelect.contains(e.target)) {
        dropdown.classList.remove('open');
        trigger.classList.remove('open');
      }
    });
  });

  // Handle free gift add to cart button clicks
  const addToCartButtons = document.querySelectorAll('.free-gift__add-button');
  addToCartButtons.forEach(button => {
    // Same duplicate-listener guard as above.
    if (button.dataset.giftInitialized) return;
    button.dataset.giftInitialized = 'true';

    button.addEventListener('click', function(e) {
      e.preventDefault();
      const card = this.closest('.free-gift__card');
      if (!card) return;
      
      const variantId = card.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('No variant ID found for free gift');
        return;
      }
      
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1,
          'properties': {
            '_free-item': 'true'
          }
        }]
      };
      
      // Disable button during request
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 422) {
          console.error('Error adding to cart:', data.description);
          button.textContent = originalText;
          button.disabled = false;
        } else {
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
          
          if (typeof load_cart == 'function') {
            load_cart();
          }

          // Open the cart drawer when the button is on the PDP (not already inside the drawer)
          if (this.closest('.pdp-free-gift')) {
            setTimeout(() => {
              document.querySelector('body').classList.add('open-drawer');
            }, 500);
          }
          
          // Update cart count
          const url = '/cart.js';
          fetch(url)
          .then((resp) => resp.json())
          .then(function(data) {
            const cartCount = data.item_count;
            if (cartCount > 0) {
              const cartCountEl = document.querySelector('.cart-count');
              if (cartCountEl) {
                cartCountEl.innerHTML = cartCount;
              }
            }
          })
          .catch(function(error) {
            console.log('Error updating cart count:', error);
          });
        }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        button.textContent = originalText;
        button.disabled = false;
      });
    });
  });

  syncPdpBanner();
}

function syncPdpBanner() {
  const pdpBanner = document.querySelector('.pdp-free-gift');
  if (!pdpBanner) return;

  // Don't override restricted banners that haven't been unlocked via session.
  if (pdpBanner.dataset.restricted === 'true' && sessionStorage.getItem('freeGiftUnlocked') !== 'true') return;

  // Only sync once the cart drawer has been rendered into the DOM.
  // If .cart-free-gift is absent, load_cart() hasn't completed yet and
  // Liquid's initial state is still correct — don't touch it.
  const cartBanner = document.querySelector('.cart-free-gift');
  if (!cartBanner) return;

  // .free-gift__card.complete is added by Liquid when cart_major >= threshold_amount.
  // It exists regardless of whether the progress bar is enabled.
  const thresholdMet = !!cartBanner.querySelector('.free-gift__card.complete');

  if (thresholdMet) {
    pdpBanner.style.removeProperty('display');
  } else {
    pdpBanner.style.display = 'none';
  }
}
